import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from '@Pages/layout/layout.component';

const routes: Routes = [
  {
    path: 'superAdmin',
    component: LayoutComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('@Pages/dashboard/dashboard.module').then((m) => m.DashboardModule),
      }, 
      {
        path: '**',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ]
  },
  {
    path: 'login',
    loadChildren: () => import('./Pages/login/login.module').then((m) => m.LoginModule)
  },
  {
    path: '**',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash:true,preloadingStrategy:PreloadAllModules})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
